import React from "react";
import PackageJson from "../../package.json";
import { navigate } from "../utilities/CustomRoute/Navigate";
import { userStore } from "../gStore/user.store";

export const Topbar = () => {
    // const [qaMode, setQaMode] = useState<boolean>(false)
    // const [activeQaUser, setActiveQaUser] = useState<string>('')
    // const [qaUsers, setQaUser] = useState<IQAUser[]>([
    //     { id: '1-1', name: 'Demo Tester 1' },
    //     { id: '1-2', name: 'Demo Tester 2' },
    //     { id: '1-3', name: 'Demo Tester 3' },
    //     { id: '1-4', name: 'Demo Tester 4' },
    // ])
    // useEffect(() => {
        // if (searchParams.get('userId')) {
        //     setActiveQaUser(searchParams.get('userId') || '')
        // }
    // }, []);
    // useEffect(() => {
    //     if (window.location.pathname.includes('demo')) {
    //         setQaMode(true)
    //     }
    // }, [])
    return (
        <nav className="py-4 bg-dark border-b-2 border-solid border-light-dark1">
            <div className="container flex items-center">
                <div className="flex items-center gap-6">
                    <div onClick={() => navigate("home")} className='cursor-pointer inline-block'>
                        <img src={`${PackageJson.homepage}/logo192.png`} className='w-[44px] h-[44px] rounded-full object-cover' alt="logo" />
                    </div>

                    <div className="flex items-center gap-4">
                        <div onClick={() => navigate("home")} className='cursor-pointer text-[16px]'>Home</div>
                        <div onClick={() => navigate("games")} className='cursor-pointer text-[16px]'>Games</div>
                        <div onClick={() => navigate("how-to-play")} className='cursor-pointer text-[16px]'>How to Play</div>
                    </div>
                </div>
                <div className="flex items-center gap-4 ml-auto">
                    {/* {qaMode && (
                        <select className="text-black" value={activeQaUser} onChange={(e) => {
                            navigate('', { 'userId': e.target.value })
                            setTimeout(() => {
                                window.location.reload()
                            }, 500)
                        }}>
                            {qaUsers.map((qaUser) => <option key={qaUser.id} value={qaUser.id}>{qaUser.name}</option>)}
                        </select>
                    )} */}
                    {userStore.data && (
                        <div className="flex items-center gap-2 text-white cursor-pointer" onClick={() => navigate("account")}>
                            <img className='w-[32px] h-[32px] rounded-full object-cover' src={userStore.data.user.avatar} alt="Avatar" />
                            <span className='font-bold text-[14px]'>{userStore.data.user.first_name} {userStore.data.user.last_name}</span>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    )
}